import React, { useState, useEffect } from "react";
import ajaxStationSales from "../../util/remote/ajaxStationSales";
import toast from "react-hot-toast";
import dictionary from "../../util/dictionary";
export default function BestAttendantCard() {
  const station_idd = Number(window.localStorage.getItem("FuelFy@station_id"));
  const [attendant, setAttendant] = useState(null);
  const [loading, setLoading] = useState(false);
  // Fetch best station attendant
  const fetchBestAttendant = async () => {
    setLoading(true);
    const data = { station_id: station_idd };
    const response = await ajaxStationSales.best_station_attendant_in_sales(
      data
    );
    if (response.status === "OK") {
      setAttendant(response.details || null);
    } else {
      toast.error(response.message || "Failed to load attendant");
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchBestAttendant();
  }, [station_idd]);
  if (loading) {
    return <p>Loading...</p>;
  }
  if (!attendant) {
    return <p>No attendant data available</p>;
  }
  return (
    <div className="card-body text-center">
      <div className="user-lock text-center">
        <h6 className="mb-1">Best Attendant of the Month</h6>
        <img
          alt="avatar"
          className="rounded-circle"
          src={`${dictionary.apiHost}/uploads/${attendant.photo}`}
          style={{ width: "100px", height: "100px" }}
        />
      </div>
      <h6 className="mb-1 mt-3">
        {attendant.first_name} {attendant.last_name}
      </h6>
      <p className="mb-1 mt-1 tx-inverse">
        Total Sales:
        <strong>{Number(attendant.total_amount).toLocaleString()} UGX</strong>
      </p>
      <p className="mb-2 mt-1 tx-inverse">
        Total Litres Sold: <strong>{attendant.total_litres} L</strong>
      </p>
      <div className="text-muted text-center mt-0">
        Best performing attendant based on total litres dispensed
      </div>
    </div>
  );
}
